module.exports = __webpack_public_path__ + "img/resp-quiz.4cdae1e5.svg";